export default {"src":"/_next/static/media/Error.af9ee723.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};